/**毫秒时间*/
export const getCurrentTimeInMillis = () => {
  return Date.now().toString();
};
/**获取当前时间 ，年，月的偏差*/
export const getCurrentDate = (
  type: string,
  yearDiff: number,
  monthDiff: number
) => {
  const dt = new Date();
  const y = dt.getFullYear() + yearDiff;
  const m = ((dt.getMonth() + monthDiff)+'').padStart(2, "0");
  /*const m = (dt.getMonth() + monthDiff + '').padStart(2, '0')*/
  const d = (dt.getDate() + "").padStart(2, "0");
  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");
  let res = "";
  switch (type) {
    case "yyyy-mm-dd":
      res = y + "-" + m + "-" + d;
      break;
    case "yyyymmddhhmmss":
      res = y + "" + m + "" + d + "" + hh + "" + mm + "" + ss;
      break;
    case "hh":
      res = hh;
      break;
    default:
      res = y + "-" + m + "-" + d + " " + hh + ":" + mm + ":" + ss;
  }
  return res;
};
/**转换时间格式*/
export const formatDateTime = (date: Date | string, type: string) => {

  if (isNull(date) === true) {
    return "0";
  }

  const dt = new Date(date);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");
  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");

  let res = "";
  switch (type) {
    case "yyyy-mm-dd":
      res = y + "-" + m + "-" + d;
      break;
    case "yyyymmdd000000":
      res = y + m + d + "000000";
      break;
      case "yyyymmdd000001":
        res = y + m + d + "000001";
        break;
    case "yyyymmdd999999":
      res = y + m + d + "999999";
      break;
    case "yyyymmdd":
      res = y + m + d;
      break;
    case "yyyymm":
      res = y + m;
      break;
    case "yyyy":
      res = y.toString();
      break;
    case "yyyymm01":
      res = y + m + "01";
      break;
    case "yyyymmddhhmmss":
      /**特殊处理,如果秒是00，更改为01，要不查询有问题 */
      if (ss == "00") {
        res = y + m + d + hh + mm + "01";
      } else {
        res = y + m + d + hh + mm + ss;
      }
      break;
    default:
      res = y + "-" + m + "-" + d + " " + hh + ":" + mm + ":" + ss;
  }
  return res;
};
/**转换时间格式。数字转字符串*/
export const formatNumberDateTime = (val: number, type: string) => {
  if (val === 0 || isNull(val) === true) {
    return "";
  }

  const dt = val.toString().padEnd(14, "0");
  const y = dt.substring(0, 4);
  const m = dt.substring(4, 6);
  const d = dt.substring(6, 8);
  const hh = dt.substring(8, 10);
  const mm = dt.substring(10, 12);
  const ss = dt.substring(12, 14);

  let res = "";
  switch (type) {
    case "yyyy-mm-dd":
      res = `${y}-${m}-${d}`;
      break;
    case "yyyy-mm-dd hh:mm:ss":
      res = `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      break;
    default:
      res = `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      break;
  }
  return res;
};
/*判断数据是否为null*/
export const isNull = (data: any) => {
  if (!data || data === "undefined" || data === "NaN" || data === "null")
    return true;
  if (JSON.stringify(data) === "{}") return true;
  if (JSON.stringify(data) === "[]") return true;
  return false;
};
/**检验key*/
export const inspectKey = (val: string) => {
  let res = false;
  try {
    if (!isNull(val) && val.length === 32) {
      res = true;
    }
  } catch {
    res = false;
  }
  return res;
};
/**解析token*/
export const FormatToken = (val: string) => {
  return decodeURIComponent(
    escape(
      window.atob(val.replaceAll("-", "+").replaceAll("_", "/").split(".")[1])
    )
  );
};
/**焦点事件：选中文本内容*/
export const onFocus = async (event: any) => {
  event.currentTarget.select();
};
/**录入框，阻止对称key录入*/
export const onPreventInput = (event: any) => {
  /*
在keyup下不成功
  if (event.key === "(" ||event.shiftKey || (event.shiftKey && event.key === '(') || (event.shiftKey && event.key === ')')) {
    event.preventDefault();
  }
  */
};
/**键盘事件:禁用左右键 */
export const onPreventLeftRight = (e: any) => {
  const keyCode = window.event ? e.keyCode : e.which;
  if (e.preventDefault) {
    if (keyCode == 37 || keyCode == 39) {
      e.preventDefault();
    }
  } else {
    if (keyCode == 37 || keyCode == 39) {
      /**window.event.returnValue=false;*/
    }
  }
};
/**空转零*/
export const convertEmptyToZero = (val: any) => {
  if (isNull(val)) {
    return 0;
  } else {
    return val;
  }
};
/**零转空*/
export const convertZeroToEmpty = (val: any) => {
  if (val === 0 || val === 0.0) {
    return undefined;
  } else {
    return val;
  }
};
/**字符串转整数*/
export const convertStringToNumber = (val: any) => {
  if (isNull(val) === true) {
    return 0;
  }

  let res = 0;
  try {
    res = Math.floor(parseInt(val));
  } catch {
    res = 0;
  }
  return res;
};

/**空转空格*/
export const convertEmptyToSpace = (val: any, num: number) => {
  let space = "\xa0";
  if (isNull(val) === true) {
    for (let i = 0; i < num; i++) {
      space += "\xa0";
    }
    return space;
  } else {
    return val;
  }
};

/**获取随机字符串 */
export const getRandom = (len: number) => {
  let str = "";
  const arr = new Array( 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w','x','y','z','0','1','2','3','4','5','6','7','8','9') as any;

  for (let i = 0; i < len; i++) {
    //设置随机数范围为0 ~ 36
    const index = Math.floor(Math.random() * 36);
    //字符串拼接每次随机的字符进行一次拼接
    str += arr[index];
    }
  return str;
};

/**数据导出*/
//import * as XLSX from 'xlsx';
import XLSX from "xlsx-js-style";

import { ElMessage } from "element-plus";

export const exportExcelTable = async (
  json: any,
  name: any,
  titleArr: any,
  sheetName: any,
  fields: any
) => {
  let data = new Array();
  if (!Array.isArray(json)) {
    return;
  } //console.warn('数据请传入数组');
  if (!Array.isArray(titleArr)) {
    return;
  } //console.warn("标题请传入数组");
  if (!Array.isArray(fields)) {
    return;
  } //console.warn("字段请传入数组");

  /**导出对应字段的数据*/
  data = json.map((obj: any) => {
    return fields.map((field: any) => {
      return obj[field];
    });
  });

  /**零转空 */
  data.forEach((item) => {
    for (let i = 0; i < item.length-1; i++) {
      //item[i] === 0 ? (item[i] = "") : item[i];
     isNull(item[i])? (item[i] = "") : item[i];
    }
  });

  data.splice(0, 0, titleArr);
  /**fields为英文字段表头,一般不需要，需要直接把下面注释打开即可*/
  /**data.splice(0, 0, fields);*/

  const ws = XLSX.utils.aoa_to_sheet(data);

  /**调用设置表格样式*/
  setExlStyle(ws);

  /**设置每列固定宽度 */
  /**定义第一列 */
  // ws["!cols"] = [{ wch: 15 }];
  // /**循环其他列 */
  // for (let i = 0; i < titleArr.length - 1; i++) {
  //   ws["!cols"].push({ wch: 15 });
  // }

  const wb = XLSX.utils.book_new();
  /** 此处隐藏英文字段表头 */
  //const wsrows = [{ hidden: true }];
  //ws["!rows"] = wsrows; // ws - worksheet
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  /* generate file and send to client */
  XLSX.writeFile(wb, name + ".xlsx");

  ElMessage({
    message: "操作成功",
    duration: 1000,
  });
};

/**配载+数据 */
export const exportExcelTableMore = async (
  json1: any,
  titleArr1: any,
  fields1: any,

  json2: any,
  titleArr2: any,
  fields2: any,

  name: any,
  sheetName: any
) => {
  let data1 = new Array();
  if (!Array.isArray(json1)) {
    return;
  }
  if (!Array.isArray(titleArr1)) {
    return;
  }
  if (!Array.isArray(fields1)) {
    return;
  }

  let data2 = new Array();
  if (!Array.isArray(json2)) {
    return;
  }
  if (!Array.isArray(titleArr2)) {
    return;
  }
  if (!Array.isArray(fields2)) {
    return;
  }

  /**导出对应字段的数据*/
  data1 = json1.map((obj: any) => {
    return fields1.map((field: any) => {
      return obj[field];
    });
  });

  /**导出对应字段的数据*/
  data2 = json2.map((obj: any) => {
    return fields2.map((field: any) => {
      return obj[field];
    });
  });

  /**零转空 */
  data2.forEach((item) => {
    for (let i = 0; i < item.length; i++) {
      if (isNull(item[i])) {
        item[i] = "";
      } else {
        item[i] === 0 ? (item[i] = "") : item[i];
      }
    }
  });

  data1.splice(0, 0, titleArr1);
  /**fields为英文字段表头,一般不需要，需要直接把下面注释打开即可*/
  /**data1.splice(0, 0, fields);*/

  data2.splice(0, 0, titleArr2);
  /**fields为英文字段表头,一般不需要，需要直接把下面注释打开即可*/
  /**data2.splice(0, 0, fields);*/

  const ws = XLSX.utils.aoa_to_sheet(data1);
  XLSX.utils.sheet_add_aoa(ws, data2, {
    origin: "A4",
  }); /**向工作表中追加一个表格，并设置从哪个单元格开始*/

  /**调用设置表格样式*/
  setExlStyle(ws);

  /**设置每列固定宽度 */
  /**定义第一列 */
  ws["!cols"] = [{ wch: 15 }];
  /**循环其他列 */
  for (let i = 0; i < titleArr1.length - 1; i++) {
    ws["!cols"].push({ wch: 15 });
  }

  const wb = XLSX.utils.book_new();
  /** 此处隐藏英文字段表头 */
  //const wsrows = [{ hidden: true }];
  //ws["!rows"] = wsrows; // ws - worksheet
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  /* generate file and send to client */
  XLSX.writeFile(wb, name + ".xlsx");

  ElMessage({
    message: "操作成功",
    duration: 1000,
  });
};

/**数据 */
export const exportExcelTableAndCount = async (
  json1: any,
  titleArr1: any,
  fields1: any,

  json2: any,
  titleArr2: any,
  fields2: any,

  name: any,
  sheetName: any,
  total: any
) => {
  let data1 = new Array();
  if (!Array.isArray(json1)) {
    return;
  }
  if (!Array.isArray(titleArr1)) {
    return;
  }
  if (!Array.isArray(fields1)) {
    return;
  }

  let data2 = new Array();
  if (!Array.isArray(json2)) {
    return;
  }
  if (!Array.isArray(titleArr2)) {
    return;
  }
  if (!Array.isArray(fields2)) {
    return;
  }

  /**导出对应字段的数据*/
  data1 = json1.map((obj: any) => {
    return fields1.map((field: any) => {
      return obj[field];
    });
  });
  /**零转空 */
  data1.forEach((item) => {
    for (let i = 0; i < item.length; i++) {
      //item[i] === 0 ? (item[i] = "") : item[i];
      isNull(item[i]) ? (item[i] = "") : item[i];
    }
  });
  /**导出对应字段的数据*/
  data2 = json2.map((obj: any) => {
    return fields2.map((field: any) => {
      return obj[field];
    });
  });
  /**零转空 */
  data2.forEach((item) => {
    for (let i = 0; i < item.length-1; i++) {
      // if (isNull(item[i])) {
      //   item[i] = "";
      // } else {
      //   item[i] === 0 ? (item[i] = "") : item[i];
      // }
      isNull(item[i]) ? (item[i] = "") : item[i];
    }
  });

  data1.splice(0, 0, titleArr1);
  /**fields为英文字段表头,一般不需要，需要直接把下面注释打开即可*/
  /**data1.splice(0, 0, fields);*/

  /**data2.splice(0, 0, titleArr2); 统计的标题*/
  /**fields为英文字段表头,一般不需要，需要直接把下面注释打开即可*/
  /**data2.splice(0, 0, fields);*/

  /** */
  const ws = XLSX.utils.aoa_to_sheet(data1);

  /**拼接统计数据*/
  if (total > 1) {
    /**向工作表中追加一个表格，并设置从哪个单元格开始*/
    const count = "A" + (total + 2).toString();
    XLSX.utils.sheet_add_aoa(ws, data2, { origin: count });
  }

  /**调用设置表格样式*/
  setExlStyle(ws);

  /**设置每列固定宽度 */
  /**定义第一列 */
  // ws["!cols"] = [{ wch: 15 }];
  // /**循环其他列 */
  // for (let i = 0; i < titleArr1.length - 1; i++) {
  //   ws["!cols"].push({ wch: 15 });
  // }

  const wb = XLSX.utils.book_new();

  /** 此处隐藏英文字段表头 */
  //const wsrows = [{ hidden: true }];
  //ws["!rows"] = wsrows; // ws - worksheet
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  /*生成文件，导出到客户端 */
  XLSX.writeFile(wb, name + ".xlsx");

  // console.log(ws)

  //   const wbout = XLSX.write(wb, {
  //     bookType: 'xlsx',
  //     bookSST: false,
  //     type: 'binary',
  //   })
  //   saveAs(
  //     new Blob([s2ab(wbout)], {
  //       type: 'application/octet-stream'
  //     }),
  //     name + ".xlsx" // 保存的文件名
  //   )

  ElMessage({
    message: "操作成功",
    duration: 1000,
  });
};

const s2ab = (s: any) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

/**设置表格的样式*/
const setExlStyle = (data: any) => {
  /**单元格外侧框线*/
  const borderAll = {
    top: {
      style: "thin",
    },
    bottom: {
      style: "thin",
    },
    left: {
      style: "thin",
    },
    right: {
      style: "thin",
    },
    //   diagonal: {
    //     style: "thin",
    //     color: "red"
    //   },
  };

  for (const key in data) {
    // 判断是否为excel表头
    //   if (key === 'A1') {
    //     data[key].s = {
    //       font: {
    //         name: '微软黑体', //字体类型
    //         sz: 12, //字体大小
    //         color: { rgb: 'ff0000' }, //字体颜色
    //         bold: false, //是否加粗
    //       },
    //       fill: {
    //         patternType: 'solid',     // 默认 solid，设为 none 时，fgColor 失效
    //         bgColor: {                // 无效
    //           rgb: "0000FF",
    //         },
    //         fgColor: {        // 背景色
    //           theme: "2",
    //           tint: "-0.25"
    //         }
    //       },
    //     }
    //     continue;
    //   }

    if (data[key] instanceof Object) {
      data[key].s = {
        /**边框*/
        border: borderAll,
        /**对齐方式相关样式*/
        alignment: {
          vertical: "center" /**垂直对齐方式*/,
          horizontal: "center" /**水平对齐方式*/ /**自动换行*/,
          /**wrapText: true,*/
        },
        /**字体相关样式*/
        font: {
          name: "微软黑体",
          sz: 12,
          /**color: { rgb: '' }, 字体颜色*/
          /**bold: false, 是否加粗*/
        },
        /**背景相关样式*/
        /**bold: true,*/
        /**numFmt: 0,*/
      };
    }
  }
  return data;
};

/**格式化银行卡号（每4位加空格）*/
export const formatBankAccount = (val:string) => {
  /**先移除所有非数字字符*/
  let newVal = val.replace(/\D/g, '');
  
  /**每4位加一个空格*/
  newVal = newVal.replace(/(\d{4})(?=\d)/g, '$1 ');
  
  return newVal;
};